import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import LogRocket from 'logrocket';

if (environment.production) {
  enableProdMode();
}

if (environment.logrocket || window.location.search.includes('logrocket')) {
  LogRocket.init('8d5gxw/tambour-color-validator', {
    dom: {
      baseHref: 'https://storage.googleapis.com/tambour-logrocket-resources/wwwroot/en-US',
    },
  });
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
